var _style, _path, _path2, _path3, _rect, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOliveOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#BAD1C1;}\n\t.st2{fill:#F8EEE1;}\n\t.st3{fill:none;stroke:#6D5F1A;stroke-width:1.6293;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#C8B65F;}\n\t.st5{fill:#BBA330;}\n\t.st6{fill:none;stroke:#F8EEE1;stroke-width:1.6293;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,151.26,61.62,185.55,104.31,185.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.58,53.83H92.87c-0.67,0-1.29,0.24-1.69,0.65c-3.61,3.73,3.74,10.62,5.26,11.96 c0.4,0.36,0.98,0.56,1.59,0.56h12.4c0.61,0,1.19-0.2,1.59-0.56c1.51-1.34,8.87-8.23,5.26-11.96 C116.87,54.07,116.25,53.83,115.58,53.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.22,85.5c1.98,0.84,3.6,2.94,3.6,4.67v68.99c0,1.73-1.85,3.15-4.11,3.15H83.74c-2.26,0-4.11-1.42-4.11-3.15 V90.18c0-1.73,1.62-3.83,3.6-4.67l7.69-3.25c1.98-0.84,3.6-2.94,3.6-4.67v0.2c0-1.73-1.48-3.15-3.29-3.15 c-1.81,0-3.29-1.42-3.29-3.15v-4.6c0-1.73,1.85-3.15,4.11-3.15h24.39c2.26,0,4.11,1.42,4.11,3.15v4.6c0,1.73-1.48,3.15-3.29,3.15 c-1.81,0-3.29,1.42-3.29,3.15v-0.2c0,1.73,1.62,3.83,3.6,4.67L125.22,85.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.69,
    y: 95.28,
    className: "st2",
    width: 41.08,
    height: 62.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.15,109.69c-11.3,2.71-22.93,14.09-26.27,20.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.84,113.83c-2.23,2.95-3.58,5.89-3.1,9.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 111.22,
    cy: 129.8,
    rx: 7.57,
    ry: 9.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 110.71,
    cy: 129.3,
    rx: 7.06,
    ry: 9.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5308 -0.8475 0.8475 0.5308 -69.194 143.2015)",
    className: "st4",
    cx: 94.74,
    cy: 134.1,
    rx: 9.73,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5308 -0.8475 0.8475 0.5308 -68.685 142.7365)",
    className: "st5",
    cx: 94.57,
    cy: 133.4,
    rx: 9.23,
    ry: 7.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.07,113.17c-4.27-2.68-9.98-1.17-15.39,5.36C90.68,118.52,101.74,122.77,106.07,113.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.52,115.98c5.97-2.55,7.88-3.18,9.95-2.31s6.53-0.56,9.07-1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.25,127.07c-1.8,0.32-4.35,1.59-5.63,4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109.49,122.38c-1.45,1.13-3.1,3.44-3.03,6.29"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105,110.7c-0.02-1.45,0.6-2.9,1.67-3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOliveOil);
export default __webpack_public_path__ + "static/media/Olive_oil.1d309a6dcbb4f544336e8358f00b3bc2.svg";
export { ForwardRef as ReactComponent };